import { useMutation } from "react-query";
import servicesUtils from "../../../utils/servicesUtils";
function useUpdateFieldConfig() {
  return useMutation(function (_ref) {
    var workspaceId = _ref.workspaceId,
      fieldName = _ref.fieldName,
      data = _ref.data;
    return servicesUtils.putService("/acr/fields/".concat(workspaceId, "/").concat(fieldName, "/"), data);
  });
}
export default useUpdateFieldConfig;